module.exports = __webpack_public_path__ + "static/media/logo-provincie-noord-holland.8e191ad0.png";